import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';
import { parseLogin } from '../../../../../../@casino/lib/parseLogin';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        paddingTop: 0,
    },
    rootTable: {
        width: 'calc(100% - 30px)', borderCollapse: 'inherit', borderSpacing: 0,
        '.trTable': {
            
        }
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
}));


const columns = [
    { id: 'id',             label: 'id'},
    { id: 'event_date',     label: 'Дата'},
    { id: 'login_user',     label: 'Логин пользователя'},
    { id: 'tag',            label: 'Событие'},
    { id: 'summ',           label: 'Сумма'},
    { id: 'payment',        label: 'Платежная система'},
];

const getRows = (replenishment) => {
    
    return replenishment.data.map((item) => {
        
        return {
            id: item.id,
            event_date: getDate(+item.event_date),
            login_user: parseLogin(item.login_user),
            tag: item.tag === 'replenishment' ? item.air ? 'Пополнение баланса (Воздух)' : 'Пополнение баланса' : 'Неизвестно',
            summ: new Intl.NumberFormat('ru-RU').format(item.summ) + '₽',
            payment: item.payment,
        }
    })
}

export {
    useStyles,
    columns,
    getRows
}